<template>
  <div>
    <v-simple-table class="borderless-table">
      <template v-slot:default>
        <thead>
          <tr>
            <th>
              Name
            </th>
            <th>
              State
            </th>
            <th>
              Expiry Date
            </th>
            <th>
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item,index) in mergedDocumentsList"
            :key="item.type + index"
            class="bg-white"
          >
            <td :style="{fontWeight: checkForMandatoryDoc(item.type) ? 'bold' : 'normal'}">
              {{ getDocumentTypeValue(item.type) }}
            </td>
            <td :style="{color: item.state == null || item.state === 'missing' ? 'red' : 'black'}">
              {{ item.state == null || item.state === 'missing' ? "MISSING" : item.state}}
            </td>
            <td :style="{color: checkDocumentExpiryDate(item.expiry_time) ? 'red' : 'black'}">
              {{ item.expiry_time }}
            </td>
            <td>
              <v-btn
                text
                x-small
                class="blue--text"
                @click="prepareUploadDialog(item)"
              >
                Upload
              </v-btn>
              <v-btn
                text
                class="blue--text"
                x-small
                @click="handleViewDocument(item.id)"
              >
                View
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-layout>
      <v-container>
        <v-flex>
          <v-dialog
            v-model="uploadDialog"
            width="500"
          >
            <v-card class="pa-3">
              <v-card-title class="headline grey lighten-2">
                Uploaded Document
                <v-spacer></v-spacer>
                <v-icon @click="uploadDialog = false">mdi-close</v-icon>
              </v-card-title>
              <UploadDriverDocument
                  class="pa-2"
                  :driver-document="selectedDocument"
                  :driver-id="this.driverId"
                  @documentProcessed="refreshDocuments"
                  @viewDocument="handleViewDocument(selectedDocument.id)"/>
            </v-card>
          </v-dialog>
        </v-flex>
      </v-container>
    </v-layout>
  </div>
</template>

<script>
import axios from 'axios'
import UploadDriverDocument from '../../components/document/UploadDriverDocument'

export default {
  name: "DriverDocumentsBox",
  components: {UploadDriverDocument},
  props: {
    driverId: {
      default: null,
      type: String
    },
    driver: {
      default: null,
      type: Object
    }
  },
  data () {
    return {
      uploadDialog: false,
      documentTypes: [
        {
          type: 'DVLA Drivers badge (front & back)',
          value: 'dvla_license'
        },
        {
          type: 'Professional Looking Selfie - for your profile picture',
          value: 'profile_picture'
        },
        {
          type: 'Proof of address',
          value: 'proof_of_address'
        },
        {
          type: 'Private Hire Badge',
          value: 'private_hire_license'
        },
        {
          type: 'Hackney Carriage',
          value: 'hackney_license'
        },
        {
          type: 'Form B',
          value: 'form_b'
        },
        {
          type: 'DBS',
          value: 'dbs'
        },
        {
          type: 'Operators License',
          value: 'operators_license'
        },
        {
          type: 'Public Liability Insurance',
          value: 'public_liability_insurance'
        },
        {
          type: 'Employers Liability Insurance',
          value: 'employers_liability_insurance'
        },
        
      ],
      selectedDocument: ""
    }
  },
  computed:{
    mergedDocumentsList () {

      // return most recent completed document as the 'primary' document in the list

      let list = []
      this.documentTypes.forEach(documentType => {
        let existingDoc = this.driverDocuments.find(driverDocument => {
          return driverDocument.type == documentType.value && driverDocument.state == 'completed'
        })


        if (existingDoc) {
          list.push(existingDoc)
        }

        let existingRequiresVerificationDoc = this.driverDocuments.find(driverDocument => {
          return driverDocument.type == documentType.value && driverDocument.state == 'pending'
        })

        if (existingRequiresVerificationDoc) {
          list.push(existingRequiresVerificationDoc)
        } /*else if (!existingDoc){
          list.push(documentType)
        }*/

        let missingDoc = this.driverDocuments.find(driverDocument => {
          return driverDocument.type == documentType.value && driverDocument.state == 'missing'
        })

        if (missingDoc) {
          list.push(missingDoc)
        } else if (!existingDoc){
          list.push(documentType)
        }
        
      })
      return list
    },
    driverDocuments () {
      return this.$store.getters['document/getDriverDocuments'];
    }
  },
  created() {
    this.loadDocuments()
  },
  methods: {
    getDocumentTypeValue: function(targetValue) {
      let documentType = this.documentTypes.find(type => type.value === targetValue);
      if(documentType === undefined){
        documentType = this.documentTypes.find(docType => docType.type === targetValue);
      }

      return documentType.type ;
    },
    prepareUploadDialog (document) {
      this.selectedDocument = document
      console.log("Selected Document in Upload", this.selectedDocument);
      this.uploadDialog = true
    },
    handleViewDocument: function (fileID) {
      let documentFile = this.driverDocuments.find(function (document) {
        return document.id === fileID;
      });
    
      let self = this;
      let url = `${this.$store.state.apiUrl}/driver/getDocumentUrl`;
      axios({
        url: url,
        method: "GET",
        params: {
          key: documentFile.filename,
        },
      })
        .then(function (response) {
          if (response.data.error) {
            self.snackbarMessage = "Failed to retrieve file";
            self.snackbarColour = "error";
            self.snackbarShow = true;
          } else {
            const link = document.createElement("a");
            link.href = response.data.url;
            link.target = "_blank";
            link.setAttribute("download", documentFile.name);
            document.body.appendChild(link);
            link.click();
          }
        })
        .catch(function (error) {
          console.log(error);
          self.snackbarMessage = "Failed to retrieve file";
          self.snackbarColour = "error";
          self.snackbarShow = true;
        });
    },
    loadDocuments () {
      this.$store.dispatch('document/getDriverDocuments', this.driverId)
    },
    refreshDocuments() {
      this.uploadDialog = false;
      this.loadDocuments();
    },
    checkDocumentExpiryDate: function (expiryDate) {
      let expiry = new Date(expiryDate);
      let today = new Date();

      return expiry < today;
    },
    checkForMandatoryDoc: function (documentType) {
      // let mandatoryDocs = ['dvla_license', 'profile_picture', 'proof_of_address', 'private_hire_license', 'hackney_license', 'form_b', 'dbs', 'operators_license', 'public_liability_insurance', 'employers_liability_insurance']
      let mandatoryDocs = ['dvla_license', 'private_hire_license', 'hackney_license']
      return mandatoryDocs.includes(documentType)
    }
  }
}
</script>

<style >

.borderless-table table tr td,th {
  border: none !important;
}


</style>